<h3>Merge documents</h3>
<p class="text-gray-600 mb-5">
	Name and reorder the following
	<span class="font-bold">{{ data.documents?.length }}</span> documents to
	merge.
</p>
<form #form="ngForm" (ngSubmit)="createMergedDocument(form)">
	<app-input
		type="text"
		label="Document name"
		name="title"
		class="mb-5 mt-3"
		[(ngModel)]="title"
		[required]="true"
	></app-input>
	<div
		class="draggable-list draggable-item draggable-boundary mx-4 flex flex-col divide-y"
		cdkDropList
		(cdkDropListDropped)="onDrop($event)"
	>
		<div
			class="merge-list-item mb-3 p-4 flex gap-3 items-center cursor-move"
			cdkDrag
			cdkDragBoundary=".draggable-boundary"
			cdkDragLockAxis="y"
			*ngFor="let document of data.documents; trackBy: documentIndex"
		>
			<app-icon classes="text-md text-gray-400" [icon]="ICON.SORT"></app-icon>
			<app-icon classes="text-md text-gray-600" icon="file"></app-icon>
			<div>{{ document.title }}</div>
		</div>
	</div>
	<div class="flex justify-center">
		<atomic-message-bar type="info"
			>Drag the documents to reorder
		</atomic-message-bar>
	</div>
	<div class="p-2 text-red" *ngIf="error">
		{{ error }}
	</div>
	<div class="flex justify-between items-center mt-5">
		<app-button btn="tertiary" (click)="cancelModal()" [disabled]="working"
			>Cancel</app-button
		>
		<div class="flex gap-2">
			<app-button
				btn="primary"
				size="small"
				(click)="download()"
				[icon]="ICON.DOWNLOAD"
				>Download</app-button
			>
			<app-button
				type="submit"
				btn="primary"
				size="small"
				[disabled]="working || !title"
				[loading]="working"
				[icon]="ICON.COPY"
				>Merge</app-button
			>
		</div>
	</div>
</form>
